import { useIntl } from 'react-intl';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { common } from '@mui/material/colors';

import type { DispoTimeWindowType } from 'src/pages/ProjectDetailsPage/api';
import { forceTimeString } from 'src/utils/datetime';

import messages from './messages';

interface JobDateFilterProps {
  timeWindows: DispoTimeWindowType[];
  selectedJobDateId: string;
  onSelect: (jobDateId: string) => void;
}

export default function JobDateFilter({
  timeWindows,
  selectedJobDateId,
  onSelect,
}: JobDateFilterProps) {
  const { formatMessage } = useIntl();

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={1}
      px={2}
      pb={2}
      bgcolor={common.white}
    >
      {timeWindows.map(({ id, startsAt, endsAt, applicationsCount }) => {
        const selected = id === selectedJobDateId;
        const label =
          startsAt && endsAt
            ? `${forceTimeString(startsAt)} - ${forceTimeString(endsAt)}`
            : formatMessage(messages.allJobDatesLabel);

        return (
          <Chip
            key={id}
            label={`${label} · ${applicationsCount}`}
            color={selected ? 'primary' : 'default'}
            variant={selected ? 'filled' : 'outlined'}
            onClick={() => onSelect(id)}
          />
        );
      })}
    </Stack>
  );
}
